// Runtime switches. Mocks from day 1 (S5 brief): with no Supabase config, or with
// VITE_AIW_MOCK=1, the CRM runs against the in-browser mock of services/api.
// In a Container App the values arrive at RUNTIME through /config.js (nginx renders
// window.__AIW__ from env); the VITE_ values are the dev fallback.
declare global { interface Window { __AIW__?: { supabaseUrl?: string; supabaseAnonKey?: string; apiBase?: string; installerPortal?: string; customerPortal?:string } } }
const rt = (typeof window !== "undefined" && window.__AIW__) || {};
const supabaseUrl = rt.supabaseUrl || (import.meta.env.VITE_SUPABASE_URL as string | undefined) || "";
export const env = {
  supabaseUrl,
  supabaseAnonKey: rt.supabaseAnonKey || (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) || "",
  apiBase: rt.apiBase ?? ((import.meta.env.VITE_AIW_API_BASE as string | undefined) ?? ""),
  /** Where a crew reads their day.
   *
   *  A DEFAULT IN CODE, not a value nginx has to interpolate. My first version put it in the
   *  container's env and templated it into `/config.js` — and nginx refuses `${...}` it cannot
   *  resolve, so the whole config failed to load (`emerg: unknown "aiw_installer_portal" variable`)
   *  and the revision never became healthy. The address is stable, so it lives here; the runtime
   *  value still overrides it if the portal ever moves. */
  installerPortal: rt.installerPortal || (import.meta.env.VITE_AIW_INSTALLER_PORTAL as string | undefined) || "https://install.artemisflooring.com",
  customerPortal:rt.customerPortal||(import.meta.env.VITE_AIW_CUSTOMER_PORTAL as string|undefined)||"https://next.artemisflooring.com",
  mock: import.meta.env.VITE_AIW_MOCK === "1" || !supabaseUrl,
};
